import React, { useEffect, useState } from "react";

import Table from "../../Common/Table";
import TableFields from "../../../constants/DriverAssetIssuanceTracking/TableFields.json";
import { getPath, getReadableDateTime } from "../../../utils";
import BlankState from "../../Common/BlankState";
import Modal from "sushiweb/Modal";
import styled from "styled-components";

const DriverAssetIssuanceTrackingData = ({ data }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const viewFileName = (val) => {
    setModalContent(val);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const getFieldValue = (obj, key) => {
    switch (key) {
      case "info":
        return (
          <span
            onClick={() => viewFileName(JSON.stringify(obj[key], undefined, 4))}
            className="edit-options cursor-pointer"
          >
            See Value
          </span>
        );
      case "awb_number":
        return (
          <a
            href={"https://shiprocket.co/tracking/" + obj[key]}
            target="_blank"
          >
            {obj[key]}
          </a>
        );
      default:
        return obj[key];
    }
  };
  return (
    <>
      {getPath(data, "length", -1) > 0 ? (
        <>
          <Table
            list={data}
            getFieldValue={getFieldValue}
            fields={TableFields}
          />
          {showModal && (
            <Modal
              visible={showModal}
              onClose={handleClose}
              type="medium"
              showCloseIcon={true}
              slideOnMobile
              isCentered
              padding="2rem"
              preventFocus
            >
              <Preformatted style={{ fontSize: "1rem" }} className="medium">
                {modalContent}
              </Preformatted>
            </Modal>
          )}
        </>
      ) : (
        <BlankState />
      )}
    </>
  );
};

const Preformatted = styled.pre`
  overflow: scroll;
`;

export default DriverAssetIssuanceTrackingData;
